var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5218_14817"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "chart-line",
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5218_14817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M21 21L6.19 21C5.08 21 4.51 21 4.09 20.78C3.71 20.58 3.41 20.28 3.21 19.9C3 19.48 3 18.91 3 17.79L3 3M7 15L12 9L16 13L21 7",
    stroke: "#718EBF",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartLine);
export default __webpack_public_path__ + "static/media/chart-line.60101fc54650e46dc17f570818907ad8.svg";
export { ForwardRef as ReactComponent };